import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { layout, primitive } from 'styles/constants';

import { IStoreLocatorMapProps } from './types';

export const StoreLocatorMap = ({ map }: IStoreLocatorMapProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box testID="store-locator-map" style={[styles.mapWrapper, isDesktop && styles.desktopMap]}>
      {map}
    </Box>
  );
};

const styles = StyleSheet.create({
  desktopMap: {
    height: layout.full,
  },
  mapWrapper: {
    backgroundColor: primitive.$mayoEggWhite,
    display: 'flex',
    flexGrow: 1,
    flexShrink: 1,
    justifyContent: 'center',
  },
});
